// Video Trigger: open/close modal with fade, embed video
(function(){
	function toEmbedUrl(url){
		if (!url) return '';
		try {
			var u = new URL(url, window.location.href);
			var host = u.hostname.replace('www.', '');
			if (host.includes('youtube.com')) {
				var id = u.searchParams.get('v');
				if (id) return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
				// youtu.be/ or already /embed/
				var path = u.pathname || '';
				var parts = path.split('/').filter(Boolean);
				if (parts[0] === 'embed' && parts[1]) return 'https://www.youtube.com/embed/' + parts[1] + '?autoplay=1&rel=0';
			}
			if (host.includes('youtu.be')) {
				var id2 = (u.pathname || '').replace('/', '');
				if (id2) return 'https://www.youtube.com/embed/' + id2 + '?autoplay=1&rel=0';
			}
			if (host.includes('vimeo.com')) {
				var vid = (u.pathname || '').split('/').filter(Boolean).pop();
				if (vid) return 'https://player.vimeo.com/video/' + vid + '?autoplay=1&title=0&byline=0&portrait=0';
			}
			return url;
		} catch(e){ return url; }
	}

	function ensureGlobalModal(){
		var existing = document.getElementById('ws-video-modal-root');
		if (existing) return existing;
		var modal = document.createElement('div');
		modal.className = 'ws-video-modal';
		modal.id = 'ws-video-modal-root';
		modal.setAttribute('hidden', '');
		modal.innerHTML =
			'<div class="ws-video-modal__backdrop" data-video-modal-close></div>' +
			'<div class="ws-video-modal__dialog" role="dialog" aria-modal="true" aria-label="Video">' +
			'<div class="ws-video-modal__embed" data-video-embed></div>' +
			'</div>';
		document.body.appendChild(modal);
		return modal;
	}

	function initVideoTriggers(context){
		var root = context || document;
		var triggers = root.querySelectorAll('[data-video-trigger]');
		triggers.forEach(function(wrapper){
			if (wrapper.dataset.videoTriggerReady) return;
			wrapper.dataset.videoTriggerReady = '1';

			var btn = wrapper.querySelector('.ws-video-trigger__button');
			var url = wrapper.getAttribute('data-video-url') || '';

			function open(){
				if (!url) return;
				var modal = ensureGlobalModal();
				var embed = modal.querySelector('[data-video-embed]');
				if (!embed) return;
				modal.removeAttribute('hidden');
				// force reflow to transition
				void modal.offsetWidth;
				modal.classList.add('is-open');
				var iframe = document.createElement('iframe');
				iframe.width = '100%';
				iframe.height = '100%';
				iframe.src = toEmbedUrl(url);
				iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
				iframe.setAttribute('allowfullscreen', '');
				iframe.style.border = '0';
				embed.innerHTML = '';
				embed.appendChild(iframe);
				document.addEventListener('keydown', onKey);
			}

			function close(){
				var modal = document.getElementById('ws-video-modal-root');
				if (!modal) return;
				var embed = modal.querySelector('[data-video-embed]');
				modal.classList.remove('is-open');
				var handler = function(){
					modal.setAttribute('hidden', '');
					modal.removeEventListener('transitionend', handler);
				};
				modal.addEventListener('transitionend', handler);
				if (embed) embed.innerHTML = '';
				document.removeEventListener('keydown', onKey);
			}

			function onKey(e){ if (e.key === 'Escape') close(); }

			if (btn) btn.addEventListener('click', open);
			// Delegation on document for global modal close
			document.addEventListener('click', function(e){
				var target = e.target;
				if (!target) return;
				if (target.hasAttribute('data-video-modal-close')) close();
			});
		});
	}

	document.addEventListener('DOMContentLoaded', function(){ initVideoTriggers(document); });
	if (window.acf && typeof window.acf.addAction === 'function') {
		window.acf.addAction('render_block_preview', function(block){ initVideoTriggers(block && (block[0] || block)); });
		window.acf.addAction('ready', function(){ initVideoTriggers(document); });
	}
	// Expose initializer for blocks that add triggers dynamically
	window.initVideoTriggers = initVideoTriggers;
})();
